// Slides in after the user picks a type — replaces the navigate() call entirely.

import { useForm } from "react-hook-form";
import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import moment from 'moment';
import { voucherService } from "../../services/voucherService";
import { createModal } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
import LogicContext from "../../Context/LogicContext";
import CurrencyFormat from 'react-currency-format';


// ─── Icons ────────────────────────────────────────────────────────────────────
const PrintIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
    </svg>
);
const ChevronDown = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
);
const ChevronLeft = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
);
const SearchIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0" />
    </svg>
);
const XIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
);
const PlusIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
);
const UserIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
);
const MailIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
);
const PhoneIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
);
const ClockIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);
const ShieldCheckIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
);
const SendIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
    </svg>
);
const CheckCircleIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);
const GiftIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
    </svg>
);


const inputCls = "w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition";
const searchInputCls = "w-full pl-9 pr-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition";


// ─── Label + Input helpers ─────────────────────────────────────────────────────
const FormField = ({ label, children, required }) => (
    <div>
        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
            {label}{required && <span className="text-red-400 ml-0.5">*</span>}
        </label>
        {children}
    </div>
);

// ─── Status Badge Helper ───────────────────────────────────────────────────────
const VoucherStatusBadge = ({ status }) => {
    let bgClass = 'bg-gray-100 text-gray-700';

    switch (status) {
        case 'Unassigned':
            bgClass = 'bg-red-100 text-red-700 border-red-200';
            break;
        case 'Redeemed':
            bgClass = 'bg-green-100 text-green-700 border-green-200';
            break;
        case 'Open':
            bgClass = 'bg-yellow-100 text-yellow-700 border-yellow-200';
            break;
        default:
            break;
    }

    return (
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold border ${bgClass}`}>
            {status}
        </span>
    );
};





export const CreateOfflineRedeemVoucherPanel = ({ isOpen, onClose, onBack, selectedType, bankName, accountId, onSaved }) => {
    const [searchInput, setSearchInput] = useState('');
    const [otpInput, setOtpInput] = useState('');
    const [redeemInput, setRedeemInput] = useState('');
    const [otpVerified, setOtpVerified] = useState(false);
    const [otpCounter, setOtpCounter] = useState(0);
    const [voucherDetails, setVoucherDetails] = useState({});
    const [searching, setSearching] = useState(false);
    const [sendingOtp, setSendingOtp] = useState(false);
    const [verifyingOtp, setVerifyingOtp] = useState(false);
    const [redeeming, setRedeeming] = useState(false);

    const logicContext = useContext(LogicContext);
    const myPromiseModal = createModal(GeneralModal);

    // OTP countdown timer
    useEffect(() => {
        let intervalId;
        if (otpCounter > 0) {
            intervalId = setInterval(() => {
                setOtpCounter(prev => {
                    if (prev <= 1) {
                        clearInterval(intervalId);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(intervalId);
    }, [otpCounter]);

    // Reset state when panel opens OR closes
    useEffect(() => {
        if (isOpen) {
            // Opening fresh
            setSearchInput('');
            setOtpInput('');
            setRedeemInput('');
            setOtpVerified(false);
            setOtpCounter(0);
            setVoucherDetails({});
        } else if (!isOpen) {
            // Cleaning up when closed
            setSearchInput('');
            setOtpInput('');
            setRedeemInput('');
            setOtpVerified(false);
            setOtpCounter(0);
            setVoucherDetails({});
        }
    }, [isOpen]);

    const searchForVoucherById = (event) => {
        event.preventDefault();
        if (!searchInput) {
            return logicContext.showToast('Please enter a voucher number!', 'error');
        }
        setSearching(true);
        getVoucherById(searchInput);
    };

    const getVoucherById = (voucher) => {
        voucherService.searchVoucherById(voucher).then(res => {
            if (res?.data?.length) {
                setVoucherDetails(res.data[0]);
                setOtpVerified(false);
                setOtpInput('');
            } else {
                logicContext.showToast('Voucher not found!', 'error');
                setVoucherDetails({});
            }
        }).catch(err => {
            logicContext.showToast('Error getting voucher!', 'error');
        }).finally(() => {
            setSearching(false);
        });
    };

    const startOTPCounter = () => {
        setOtpCounter(30);
    };

    const sendVoucherOtp = () => {
        if (voucherDetails?.Voucher_Status_Id !== 1) {
            return logicContext.showToast('Only OPEN voucher can be processed!', 'error');
        }
        setSendingOtp(true);
        voucherService.sendVoucherOtp(voucherDetails?.Voucher_Number).then(res => {
            if (res?.data?.voucher?.length) {
                startOTPCounter();
                logicContext.showToast('Voucher OTP has been sent!', 'success');
            }
        }).catch(err => {
            console.log('send_otp_err ', err);
            logicContext.showToast('Error sending OTP!', 'error');
        }).finally(() => {
            setSendingOtp(false);
        });
    };

    const verifyOtp = (event) => {
        event.preventDefault();
        if (!otpInput) {
            return logicContext.showToast('Please enter OTP!', 'error');
        }
        if (voucherDetails?.Voucher_Status_Id !== 1) {
            return logicContext.showToast('Only OPEN voucher can be processed!', 'error');
        }
        setVerifyingOtp(true);
        voucherService.verifyOtp({
            voucher_number: voucherDetails?.Voucher_Number,
            otp_number: otpInput
        }).then(res => {
            if (res?.data?.length) {
                const data = res?.data[0];
                if (data?.message_id === 1) {
                    setOtpVerified(true);
                    logicContext.showToast(data?.message_text, 'success');
                } else {
                    logicContext.showToast(data?.message_text, 'error');
                }
            }
        }).catch(err => {
            console.log('verify_otp_err ', err);
            logicContext.showToast('Error verifying OTP!', 'error');
        }).finally(() => {
            setVerifyingOtp(false);
        });
    };

    const redeemActionClick = async () => {
        if (!redeemInput) {
            return logicContext.showToast('Please enter redeem purpose!', 'error');
        }
        if (voucherDetails?.Voucher_Status_Id !== 1) {
            return logicContext.showToast('Only OPEN voucher can be processed!', 'error');
        }

        const result = await myPromiseModal({
            title: `Confirm voucher - ${voucherDetails?.Voucher_Number}`,
            body: `Voucher will be redeemed to the owner of ${voucherDetails?.Reciepient_Mobile_Number}!`,
            showInput: false,
            placeHolder: ''
        });

        if (!result?.decision) return;

        setRedeeming(true);

        const data = {
            customer_id: voucherDetails?.Customer_Id,
            voucher_number: voucherDetails?.Voucher_Number,
            mobile_number: voucherDetails?.Reciepient_Mobile_Number,
            otp_number: otpInput,
            redeem_purpose: redeemInput
        };

        voucherService.voucherRedeemAction(data).then(res => {
            if (res?.data?.result_status?.length) {
                const tempData = res.data.result_status[0];
                if (tempData?.message_id === 1) {
                    logicContext.showToast(tempData?.message_text, 'success');
                    getVoucherById(voucherDetails?.Voucher_Number);
                    setOtpVerified(false);
                    setOtpInput('');
                    setRedeemInput('');
                    onSaved?.();
                } else {
                    logicContext.showToast(tempData?.message_text, 'error');
                }
            } else {
                logicContext.showToast('Something went wrong, please contact Admin!', 'error');
            }
        }).catch(err => {
            console.log('redeem_err ', err);
            logicContext.showToast('Error redeeming voucher!', 'error');
        }).finally(() => {
            setRedeeming(false);
        });
    };

    const hasVoucher = !!voucherDetails?.Ref_No;


    return (
        <div
            className={`fixed top-0 right-0 h-screen w-[480px] bg-white z-50 flex flex-col overflow-hidden
        transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
            style={{ borderLeft: '1px solid #e5e7eb', boxShadow: '-4px 0 24px rgba(0,0,0,0.10)' }}
        >
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 bg-gray-50 flex-shrink-0">
                <div className="flex items-center gap-2">
                    <button
                        onClick={onBack}
                        className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-200 hover:text-gray-700 transition"
                        title="Back to type selection"
                    >
                        <ChevronLeft />
                    </button>
                    <div>
                        <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest leading-none mb-0.5">
                            Voucher Redeem
                        </p>
                        <h3 className="text-base font-bold text-gray-800 leading-tight">
                            {selectedType?.transaction_name || 'Offline Redeem'}
                        </h3>
                    </div>
                </div>
                <button
                    onClick={onClose}
                    className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-200 hover:text-gray-700 transition"
                >
                    <XIcon />
                </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">

                {/* Voucher Search Section */}
                <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                    <FormField label="Voucher Number" required>
                        <div className="flex gap-2">
                            <div className="relative flex-1">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <SearchIcon />
                                </div>
                                <input
                                    className={searchInputCls}
                                    type="search"
                                    placeholder="Enter voucher number"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                            </div>
                            <button
                                disabled={!searchInput || searching}
                                onClick={searchForVoucherById}
                                className="px-4 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm flex-shrink-0"
                            >
                                {searching ? 'Searching…' : 'Search'}
                            </button>
                        </div>
                    </FormField>

                    {/* Status Badge */}
                    {voucherDetails?.Voucher_Status_Name && (
                        <div className="mt-3 flex justify-end">
                            <VoucherStatusBadge status={voucherDetails?.Voucher_Status_Name} />
                        </div>
                    )}
                </div>

                {/* Voucher Details Section */}
                {hasVoucher && (
                    <>
                        {/* Voucher Info Card */}
                        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100">
                                <div className="flex items-center gap-2">
                                    <GiftIcon />
                                    <span className="text-sm font-bold text-gray-700">Voucher Details</span>
                                </div>
                            </div>

                            <div className="p-4 space-y-3">
                                {/* Recipient Info */}
                                <div className="grid grid-cols-1 gap-2">
                                    <div className="flex items-center gap-2 text-sm">
                                        <UserIcon />
                                        <span className="text-gray-500">Recipient:</span>
                                        <span className="font-semibold text-gray-800">{voucherDetails?.Reciepient_Name}</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm">
                                        <MailIcon />
                                        <span className="text-gray-500">Email:</span>
                                        <span className="text-gray-700">{voucherDetails?.Reciepient_Email_Address}</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm">
                                        <PhoneIcon />
                                        <span className="text-gray-500">Mobile:</span>
                                        <span className="font-semibold text-gray-800">{voucherDetails?.Reciepient_Mobile_Number}</span>
                                    </div>
                                </div>

                                <hr className="border-gray-100" />

                                {/* Amount & Type */}
                                <div className="grid grid-cols-2 gap-3">
                                    <div>
                                        <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Amount</p>
                                        <p className="text-lg font-bold text-green-600">
                                            <CurrencyFormat
                                                value={parseFloat(voucherDetails?.Voucher_Amount)?.toFixed(2)}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                prefix={'₦'}
                                            />
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Voucher Type</p>
                                        <p className="text-sm font-bold text-blue-600">{voucherDetails?.Voucher_Type_Name}</p>
                                    </div>
                                </div>

                                {/* Bulk Corporate Name */}
                                {voucherDetails?.Voucher_Type_Name === 'Bulk' && (
                                    <div>
                                        <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Corporate Name</p>
                                        <p className="text-sm font-semibold text-gray-700">{voucherDetails?.Corporate_Name}</p>
                                    </div>
                                )}

                                <hr className="border-gray-100" />

                                {/* Timestamps */}
                                <div className="space-y-1">
                                    <div className="flex items-center gap-2 text-xs text-gray-500">
                                        <ClockIcon />
                                        <span>Created: {moment(voucherDetails?.Transaction_Date).format("DD-MM-YYYY HH:mm:ss")}</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-xs text-gray-500">
                                        <UserIcon />
                                        <span>Created By: {voucherDetails?.Created_By_Name}</span>
                                    </div>
                                    {voucherDetails?.Redeem_By_Name && (
                                        <div className="flex items-center gap-2 text-xs text-gray-500">
                                            <CheckCircleIcon />
                                            <span>Redeem By: {voucherDetails?.Redeem_By_Name}</span>
                                        </div>
                                    )}
                                    {voucherDetails?.Redeem_Date && (
                                        <div className="flex items-center gap-2 text-xs text-gray-500">
                                            <ClockIcon />
                                            <span>Redeem Date: {moment(voucherDetails?.Redeem_Date).format("DD-MM-YYYY HH:mm:ss")}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Note */}
                                {voucherDetails?.Purchase_Zoho_Send_Remark && (
                                    <>
                                        <hr className="border-gray-100" />
                                        <div>
                                            <p className="text-xs text-gray-400 uppercase tracking-wide mb-1">Voucher Note</p>
                                            <p className="text-sm text-gray-600">{voucherDetails?.Purchase_Zoho_Send_Remark}</p>
                                        </div>
                                    </>
                                )}

                                {/* Redeem Remark */}
                                {voucherDetails?.Redeem_Remark && (
                                    <div>
                                        <p className="text-xs text-gray-400 uppercase tracking-wide mb-1">Redeem Remark</p>
                                        <p className="text-sm text-gray-600">{voucherDetails?.Redeem_Remark}</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* OTP Section */}
                        <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 space-y-3">
                            {/* Send OTP */}
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                    <SendIcon />
                                    <span className="text-sm font-semibold text-gray-700">Send OTP</span>
                                </div>
                                <button
                                    disabled={otpCounter > 0 || sendingOtp}
                                    onClick={sendVoucherOtp}
                                    className="px-4 py-2 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm"
                                >
                                    {sendingOtp ? 'Sending…' : 'Send OTP'}
                                </button>
                            </div>

                            {otpCounter > 0 && (
                                <p className="text-xs text-amber-600 flex items-center gap-1">
                                    <ClockIcon />
                                    Resend OTP in <span className="font-bold text-red-500 mx-1">{otpCounter}</span> second(s)
                                </p>
                            )}

                            {/* Verify OTP */}
                            <div className="pt-2 border-t border-gray-200">
                                <FormField label="Enter OTP">
                                    <div className="flex gap-2">
                                        <input
                                            className={inputCls}
                                            type="text"
                                            placeholder="Enter OTP"
                                            value={otpInput}
                                            onChange={(e) => setOtpInput(e.target.value)}
                                        />
                                        <button
                                            disabled={!otpInput || verifyingOtp}
                                            onClick={verifyOtp}
                                            className="px-4 py-2.5 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm flex-shrink-0"
                                        >
                                            {verifyingOtp ? 'Verifying…' : 'Verify OTP'}
                                        </button>
                                    </div>
                                </FormField>

                                {otpVerified && (
                                    <div className="mt-2 flex items-center gap-2 text-green-600 text-sm font-semibold">
                                        <ShieldCheckIcon />
                                        OTP Verified Successfully
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Redeem Section (only visible after OTP verified) */}
                        {otpVerified && (
                            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200 space-y-3">
                                <div className="flex items-center gap-2">
                                    <CheckCircleIcon />
                                    <span className="text-sm font-bold text-green-700">Redeem Voucher</span>
                                </div>

                                <FormField label="Redeem Purpose" required>
                                    <textarea
                                        rows={3}
                                        placeholder="Enter purpose for redemption"
                                        className={`${inputCls} resize-none`}
                                        value={redeemInput}
                                        onChange={(e) => setRedeemInput(e.target.value)}
                                    />
                                </FormField>

                                <button
                                    disabled={!redeemInput || redeeming}
                                    onClick={redeemActionClick}
                                    className="w-full py-2.5 bg-green-600 text-white text-sm font-bold rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm"
                                >
                                    {redeeming ? 'Redeeming…' : 'Redeem Voucher'}
                                </button>
                            </div>
                        )}
                    </>
                )}

                {/* Empty State */}
                {!hasVoucher && (
                    <div className="flex flex-col items-center justify-center py-12 text-gray-400">
                        <SearchIcon />
                        <p className="mt-3 text-sm font-medium">Search for a voucher to begin</p>
                        <p className="text-xs mt-1">Enter a voucher number above</p>
                    </div>
                )}

                <div className="h-2" />
            </div>

            {/* Footer */}
            <div className="px-5 py-4 border-t border-gray-100 bg-gray-50 flex gap-3 flex-shrink-0">
                <button
                    type="button"
                    onClick={onClose}
                    className="flex-1 bg-white hover:bg-gray-100 text-gray-700 text-sm font-semibold py-2.5 px-4 rounded-lg border border-gray-200 transition"
                >
                    Close
                </button>
            </div>
        </div>
    );
};